export default {
	props: {
		id: {
			type: Number,
			required: true,
		}
	},
	data() {
		return {
			resource: {
				completedStep: 0,
				can: {},
			},
			deleteModal: {
				title: 'Delete resource?',
				content: 'This action cannot be undone and the user will be notified.',
				buttonLabel: 'Delete resource',
			},
		}
	},
	methods: {
		getResource() {
			this.$wait.start('fetching preview resource');

			this.fetchResource()
                .then(response => {
				    this.resource = response;
			    })
                .catch(() => {
                    this.resource = null;
                })
                .finally(() => {
                    this.$wait.end('fetching preview resource');
                });
		},
		fetchResource() {
			return Promise.reject("Not implemented");
		},
		saveResource(status) {
			this.$wait.start('fetching preview resource');
			this.updateResource(status).finally(() => this.$wait.start('fetching preview resource'));
		},
		updateResource(status) {
			return Promise.reject("Not implemented");
		},
		deleteResource() {
			return Promise.reject("Not implemented");
		},
		showDeleteModal() {
			this.$modal.show('dialog', {
				title: this.deleteModal.title,
				text: this.deleteModal.content,
				buttons: [
					{
						class: 'btn btn--danger',
						title: this.deleteModal.buttonLabel,
						handler: () => {
							this.deleteResource();
						}
					},
				]
			});
		},
		completedStep(step) {
			return this.resource.completedStep >= step;
		},
		canCompleteStep(step) {
			return this.resource.completedStep >= (step - 1);
		}
	},
	created() {
		this.getResource();
	},
    watch: {
        id: function(newId, oldId) {
            if(newId !== oldId){
                this.getResource();
            }
        }
    }
}
